import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input-multi-atom',
  templateUrl: './input-multi-atom.component.html',
  styleUrls: ['./input-multi-atom.component.scss'],
  imports: [CommonModule],
})
export class InputMultiAtomComponent {
  @Input() label!: string;
  @Input() type!: string;
  @Input() id?: string;
  @Input() active = false;
  @Input() placeholder!: string;
  @Input() value!: string;
  @Input() boldLabel = false;
  @Input() inputMode = '';
  @Input() digitsOnly = false;

  @Output() valueEmitter = new EventEmitter<string | boolean>();

  onChangeValueRadio(event: string): void {
    this.valueEmitter.emit(event);
  }

  onChangeValueCheckbox(event: any): void {
    this.valueEmitter.emit(event?.target?.checked);
  }

  onChangeTextValue(event: Event): void {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) {
      return;
    }
    let next = target.value;
    if (this.digitsOnly) {
      const digits = next.replace(/\D/g, '');
      if (digits !== next) {
        target.value = digits;
        next = digits;
      }
    }
    this.valueEmitter.emit(next);
  }

  unfocus(element: any): void {
    element?.blur();
  }
}
